import { useEffect } from "react";
import { useStore } from "zustand";

import { authStore } from "../../store/auth";
import { editContentStore } from "../../store/editContent";
import { navigationStore } from "../../store/navigation";
import { yourInsightFilterStore } from "../../store/yourInsightsFilter";
import { YourInsightFilterContentType } from "../../types/filters/yourInsights";
import { TopNavBarTabs } from "../../types/navigation";
import { hasSfObjectContext } from "../../utils/permission.utils";

export const useSfObjectContextPitchUploadEffect = (): void => {
    const [setActiveTab] = useStore(navigationStore, (state) => [
        state.setActiveTab,
    ]);

    const [userAccessRoles] = useStore(authStore, (state) => [
        state.accessRoles,
    ]);

    const [setTypes] = useStore(yourInsightFilterStore, (state) => [
        state.setTypes,
    ]);

    const [showEditModal] = useStore(editContentStore, (state) => [
        state.showEditModal,
    ]);

    useEffect(() => {
        if (hasSfObjectContext() && userAccessRoles.plm) {
            setActiveTab(TopNavBarTabs.YOUR_INSIGHT_DECKS);
            setTypes(YourInsightFilterContentType.PITCHED_CONTENT, undefined);
            showEditModal();
        }
    }, [userAccessRoles]);
};
